// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3jx-o","footer":"Form_footer__2myat"};